import setUtil from 'utils/set'
import { REDUX_STATUS } from '@gymaholic/packages'
import REDUX_OPTION from 'modules/redux/constants/option'
import {
  getObjectUtil,
  pickObjectUtil
} from 'packages/src'

function saveSuccesReduxReducer (state, action) {
  let {
    path,
    options
  } = action.payload
  const obj = getObjectUtil(state, path)
  if (!obj) {
    return state
  }
  const updates = {
    ...obj,
    status: REDUX_STATUS.SUCCESS,
    updatedAt: (new Date()).toISOString(),
    error: null,
    validation: null
  }
  options = options || {}
  const keysToKeep = options[REDUX_OPTION.KEYS_TO_KEEP]
  if (keysToKeep) {
    updates.changed = pickObjectUtil(obj.changed, keysToKeep)
  } else {
    updates.changed = {}
  }
  return setUtil(state, path, updates)
}

export default saveSuccesReduxReducer
